import { getJson, postJson } from '@/lib/apiClient';
import type { Aggregate, AggregateRow, ReportDataset } from '@/features/reporting/types';

interface Wrapped<T> {
  data: T;
}

export interface AggregateInput {
  dataset_id: string;
  dimension: string | null;
  measure: string | null;
  aggregate: Aggregate;
  limit: number;
  chart_type?: string;
}

export const reportingApi = {
  datasets: (): Promise<ReportDataset[]> =>
    getJson<Wrapped<ReportDataset[]>>('/reporting/datasets').then((r) => r.data),

  aggregate: (input: AggregateInput): Promise<AggregateRow[]> =>
    postJson<Wrapped<AggregateRow[]>>('/reporting/aggregate', input).then((r) => r.data),
};

export const reportingKeys = {
  datasets: ['reporting', 'datasets'] as const,
  aggregate: (input: AggregateInput) => ['reporting', 'aggregate', input] as const,
};
